/** Extensions — still a placeholder in the platform, so this stays a holding page. */

import { consoleConfig, route } from '../config.ts';
import { clear, el } from '../ui.ts';

export function mountExtensions(container: HTMLElement): void {
  clear(container);

  container.append(
    el('div', { class: 'console-empty' }, [
      el('p', { class: 'console-empty-title', text: 'Extensions are on the way' }),
      el('p', {
        class: 'console-empty-note',
        text:
          'Extensions will let your app add surfaces inside the Livepush dashboard. ' +
          'Nothing to configure yet — build against the REST API in the meantime.',
      }),
      el('div', { class: 'hero-actions' }, [
        el('a', { class: 'btn btn-primary', href: route('apps'), text: 'Manage my apps' }),
        el('a', {
          class: 'btn',
          href: `${consoleConfig().docsBase}guides/getting-started/`,
          text: 'Read the API guide',
        }),
      ]),
    ]),
  );
}
